<template>
  <div class="play-guide-container" v-if="list.length > 0">
    <div class="content-title-wrap">
      <div class="content-section-title">游玩攻略</div>
      <div
        @click="handleToLink"
        class="content-section-more user-evaluation-more"
        v-if="list.length > 1"
      >
        <span>全部({{ list.length }}篇)</span>
        <ycf-svg class="iconfont arrowleft" icon-name="arrowleft"></ycf-svg>
      </div>
    </div>

    <div @scroll="handleScroll" ref="scrollView" class="scroll-view-wrap">
      <div
        class="play-guide-item"
        v-for="item in list"
        :class="{ 'one-play-guide': list.length == 1 }"
        :key="item.id"
        @click="handleToLink"
      >
        <div class="strategy-item-img">
          <img class="play-guide-item-img" :src="item.cover" alt="cover" />
          <img
            v-if="item.hasVideo"
            class="tour-play-icon"
            :src="playIcon"
            alt="play-icon"
          />
          <div class="play-guide-item-title">{{ item.title }}</div>
        </div>
        <div class="strategy-item-user-info">
          <img class="play-guide-avatar" :src="item.avatarUrl" alt="avatar" />
          <div class="play-guide-item-subtitle">{{ item.nickName }}</div>
        </div>
      </div>
      <div class="play-guide-more" v-if="list.length > 1" @click="handleToLink">
        <p>查</p>
        <p>看</p>
        <p>更</p>
        <p>多</p>
        <img
          class="img-more"
          src="https://qiniu-cdn7.jinxidao.com/wxProgram/images/zby/more_icon.png"
          alt="more-icon"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Databus, { Origins } from "@ykz/ykz-http/core";
import { toast, toQueryString } from "@ykz/ykz-util/base";

export default {
  props: {
    hotelScenicId: {
      type: [String, Number],
      default: "",
    },
    goodId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      list: [],
      playIcon:
        "https://qiniu-cdn7.jinxidao.com/wxProgram/images/zby/play_big_icon.png",
    };
  },
  methods: {
    handleToLink() {
      // let url = `/front/platform/newPlatformAlbum?goodId=${this.goodId}&hotelScenicId=${this.hotelScenicId}&switchTab=strategy`;

      const url =
        "/front/platform/newPlatformAlbum?" +
        toQueryString({
          goodId: this.goodId,
          hotelScenicId: this.hotelScenicId,
          switchTab:'strategy'
        });

      location.href = url;
    },
    handleScroll(event) {
      if (this.list.length == 1) return;
      const scrollView = this.$refs.scrollView;
      if (
        scrollView.scrollLeft + scrollView.clientWidth >=
        scrollView.scrollWidth
      ) {
        this.handleToLink("list");
      }
    },
    fetchList() {
      Databus({
        url: "/apiv2/room/getLastYoujiLinkList",
        data: {
          hotelScenicId: this.hotelScenicId,
        },
        type: "GET",
        success: (res) => {
          const { code, bcode, content } = res;
          if (code == 1000 && bcode == 100) {
            this.list = content || [];
          }
          this.$emit("ready", this.list);
        },
        error: function () {
          this.$emit("ready", this.list);
          toast("网络有误，请刷新重试");
        },
      });
    },
  },
  mounted() {
    this.fetchList();
  },
};
</script>

<style lang="scss" scoped>
.play-guide-container {
  margin: pxToRem(20) 0;
  font-size: 24px;
  background-color: #fff;
  .content-title-wrap {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: pxToRem(32) pxToRem(25);
    line-height: 1;
    .content-section-title {
      color: #333333;
      font-size: pxToRem(30);
      font-weight: 700;
      line-height: 1;
      text-align: left;
    }

    .content-section-more {
      font-size: pxToRem(24);
      color: #ff7124;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      .arrowleft {
        color: #ff7124;
        font-size: pxToRem(36);
        transform: scale(0.5);
        margin-left: pxToRem(20-36/2-10);
        display: block;
      }
    }
  }

  .scroll-view-wrap {
    display: flex;
    white-space: nowrap;
    overflow-x: auto;
    width: 100%;
    padding-bottom: pxToRem(40);
    box-sizing: border-box;
    &::-webkit-scrollbar {
      display: none;
    }
    .play-guide-item {
      width: 300px;
      flex-shrink: 0;
      margin-right: 20px;
      display: inline-block;

      &.one-play-guide {
        width: 100%;
        box-sizing: border-box;
        padding: 0 pxToRem(30);
        margin: 0 !important;

        .strategy-item-img {
          height: unset;
        }
      }

      &:first-child {
        margin-left: pxToRem(30);
      }

      .strategy-item-img {
        width: 100%;
        height: 380px;
        border-radius: 12px;
        position: relative;
        overflow: hidden;

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          top: 50%;
          left: 0;
          right: 0;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.5) 100%
          );
          border-radius: 0 0 16px 16px;
        }

        .play-guide-item-img {
          width: 100%;
          height: 100%;
        }

        .tour-play-icon {
          position: absolute;
          right: 14px;
          top: 14px;
          z-index: 1000;
          width: 48px;
          height: 48px;
        }
      }

      .strategy-item-user-info {
        display: flex;
        align-items: center;
        padding-top: 20px;

        .play-guide-avatar {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          margin-right: 8px;
        }
      }

      .play-guide-item-title {
        position: absolute;
        bottom: 24px;
        color: #fff;
        padding: 0 12px;
        z-index: 1000;
        white-space: normal !important;

        @include ellipsis(2);
      }
    }

    .play-guide-more {
      width: 100px;
      height: 380px;
      box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
      border-radius: 16px;
      flex-shrink: 0;
      margin-right: 32px;
      overflow: hidden;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
        font-size: 24px;
        color: #999;
      }
      .img-more {
        position: absolute;
        bottom: 88px;
        width: 26px;
        height: 26px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
